import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { MessageFacade } from 'ish-core/facades/message.facade';

/**
 * The Info Message Component displays an info message as inline message or as toast.
 *
 * @example
 * <ish-info-message message="quote.error.not_started" [toast]="false"></ish-info-message>
 */
@Component({
  selector: 'ish-info-message',
  templateUrl: './info-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class InfoMessageComponent implements OnChanges {
  private messageFacade = inject(MessageFacade);

  readonly message = input.required<string>();
  readonly toast = input(true);

  ngOnChanges() {
    if (this.toast()) {
      this.displayToast();
    }
  }

  private displayToast() {
    const message = this.message();
    if (message) {
      this.messageFacade.info({
        message,
      });
    }
  }
}
